module.exports = __webpack_public_path__ + "assets/images/magazine_7343539fcaa87bb17c5365a2fb5eddf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-four/exercise-1/magazine.png
// module id = 278
// module chunks = 0